module.exports = __webpack_public_path__ + "static/media/BunVenit.eb621b70.jpeg";